import React, { useState, useEffect } from 'react';
import { SliderNextButton, SliderPreviousButton } from './StyledLinks';

interface IImage {
    id: number
    src: string
}

interface GalleryProps {
    images: IImage[]
}


const Gallery: React.FC<GalleryProps> = ({ images }) => {

    const [hovered, setHovered] = useState<number | null>(null);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(4);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 640);


    const totalPages = Math.ceil(images.length / itemsPerPage);

    useEffect(() => {
        const updateItemsPerPage = () => {
            setIsSmallScreen(window.innerWidth <= 640);
            setItemsPerPage(window.innerWidth <= 640 ? 2 : 4); // 2 for small screens (sm: and below), 4 for larger screens
        };

        updateItemsPerPage(); // Set initial value
        window.addEventListener('resize', updateItemsPerPage);

        return () => window.removeEventListener('resize', updateItemsPerPage);
    }, []);

    // Calculate the subset of images to display on the current page
    const displayedImages = images.slice(
        page * itemsPerPage,
        page * itemsPerPage + itemsPerPage
    );

    // Handle page navigation
    const handleNextPage = () => {
        setPage((prevPage) => (prevPage + 1) % totalPages);
    };

    const handlePrevPage = () => {
        setPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
    };

    return (
        <>
            <div
                className={`grid gap-0.5 ${itemsPerPage === 2 ? 'grid-cols-2' : 'grid-cols-4'
                    }`}
                style={{
                    gridTemplateColumns: hovered
                        ? displayedImages.map((image) =>
                            image.id === hovered
                                ? isSmallScreen ? '3fr' : '2fr'  // Increase size only on small screens
                                : '1fr'
                        ).join(' ')
                        : itemsPerPage === 2 ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
                }}
            >
                {displayedImages.map((image) => (
                    <div
                        key={image.id}
                        className={`min-w-full w-full h-[540px] bg-center bg-no-repeat bg-cover transition-all duration-700 hover:cursor-pointer ease-in-out ${hovered === image.id ? 'brightness-90' : 'brightness-75'
                            }`}
                        style={{ backgroundImage: `url(${image.src})` }}
                        onMouseEnter={() => setHovered(image.id)}
                        onMouseLeave={() => setHovered(null)}
                    ></div>
                ))}
            </div>

            <div className="flex flex-col w-full place-items-center mx-auto justify-center mt-4 space-y-6">
                <SliderPreviousButton
                    onClick={handleNextPage}
                    disabled={page === totalPages - 1}
                    className="px-4 py-2 bg-[#f9efdd] shadow-sm shadow-[#d6cab7] rounded-full font-extralight disabled:opacity-50"
                />
                <SliderNextButton
                    onClick={handlePrevPage}
                    disabled={page === 0}
                    className="px-4 py-2 bg-[#f9efdd] shadow-sm shadow-[#d6cab7] rounded-full font-extralight "
                />
            </div>
        </>
    )
}

export default Gallery